module.exports = __webpack_public_path__ + "img/submit_member_screenshot.30a9a05e.png";